import { TableOfContentOrientationEnum } from '../enums/table-of-content-orientation.enum';
import { GenericStyleModel } from '../../../Common/Styles/models/generic-style.model';
import { BriefingBlockTypeApiEnum } from '../../../api/briefings/enum/briefing-block-type-api.enum';
import { BriefingHeadingLevelEnum } from '../enums/briefing-heading-level.enum';
export class TableOfContentSettingsModel extends GenericStyleModel {
    includeMentionCount: boolean;
    includeHeadlines: boolean;
    includeTitle: boolean;
    orientation: TableOfContentOrientationEnum;
    _includeMentionSections: boolean;
    titleLevel: BriefingHeadingLevelEnum = BriefingHeadingLevelEnum.HEADING_3;

    set includeMentionSections(includeMentionSections: boolean) {
        this._includeMentionSections = includeMentionSections;

        if (!this._includeMentionSections) {
            this.includeMentionCount = false;
        }
    }

    get includeMentionSections(): boolean {
        return this._includeMentionSections;
    }

    constructor (apiModel?: any) {
        super(apiModel);

        if (!apiModel) {
            this.setDefaultModel(TableOfContentOrientationEnum.horizontal);

            this.includeTitle = false;
            return;
        }

        this.setFromApiModel(apiModel);
    }

    setFromApiModel(apiModel: any) {
        super.setFromApiModel(apiModel);

        if (typeof apiModel === 'string') {
            apiModel = JSON.parse(apiModel);
        }

        if (apiModel.hasOwnProperty('orientation')) {
            this.orientation = apiModel.orientation;
        }
        if (apiModel.hasOwnProperty('includeMentionCount')) {
            this.includeMentionCount = apiModel.includeMentionCount;
        }
        if (apiModel.hasOwnProperty('includeMentionSections')) {
            this._includeMentionSections = apiModel.includeMentionSections;
        }
        if (apiModel.hasOwnProperty('includeHeadlines')) {
            this.includeHeadlines = apiModel.includeHeadlines;
        }
        if (apiModel.hasOwnProperty('includeTitle')) {
            this.includeTitle = apiModel.includeTitle;
        }
        if (apiModel.hasOwnProperty('titleLevel')) {
            this.titleLevel = apiModel.titleLevel;
        }
    }

    toBlockStyle(): any {
        const blockStyle: any = {
            includeMentionCount: this.includeMentionCount,
            includeHeadlines: this.includeHeadlines,
            includeTitle: this.includeTitle,
            orientation: this.orientation,
            includeMentionSections: this._includeMentionSections
        };
    }

    /**
     * Creates a clone of the model
     */
    clone(): TableOfContentSettingsModel {
        return new TableOfContentSettingsModel(this.toApi());
    }

    /**
     * Returns api model
     */
    toApi(): any {
        return {
            orientation: this.orientation,
            includeMentionCount: this.includeMentionCount,
            includeMentionSections: this._includeMentionSections,
            includeHeadlines: this.includeHeadlines,
            includeTitle: this.includeTitle,
            titleLevel: this.titleLevel
        };
    }

    /**
     * Returns true if models are equal
     */
    equals(other: TableOfContentSettingsModel): boolean {
        if (other.orientation !== this.orientation) {
            return false;
        }
        if (other.includeMentionCount !== this.includeMentionCount) {
            return false;
        }
        if (other._includeMentionSections !== this._includeMentionSections) {
            return false;
        }
        if (other.includeHeadlines !== this.includeHeadlines) {
            return false;
        }
        if (other.includeTitle !== this.includeTitle) {
            return false;
        }
        if (other.titleLevel !== this.titleLevel) {
            return false;
        }

        return true;
    }

    /**
     * Sets the default option based on orientation
     */
    setDefaultModel(orientation: TableOfContentOrientationEnum) {
        if (orientation === TableOfContentOrientationEnum.horizontal) {
            this.orientation = TableOfContentOrientationEnum.horizontal;
            this.includeMentionCount = false;
            this._includeMentionSections = true;
            this.includeHeadlines = false;
        } else {
            this.orientation = TableOfContentOrientationEnum.vertical;
            this.includeMentionCount = true;
            this._includeMentionSections = true;
            this.includeHeadlines = false;
        }
    }

    /**
     * Changes orientation of the model
     */
    changeOrientation(orientation: TableOfContentOrientationEnum) {
        this.setDefaultModel(orientation);
    }

    /**
     * Returns true if provided block type is included by settings model
     */
    isBlockTypeIncludedBySettings(blockType: BriefingBlockTypeApiEnum): boolean {
        switch (blockType) {
            case BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST:
            case BriefingBlockTypeApiEnum.CURATED_MENTION_LIST:
                return this._includeMentionSections || this.includeHeadlines;
            case BriefingBlockTypeApiEnum.TITLE:
                return this.includeTitle;

            default:
                return false;
        }
    }
}
